import React, { useContext, useState, useEffect, useRef } from 'react'
import './viewdoc.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import QrImg from '../../assets/qr-code.png'
import Sign from '../../assets/signature.png'
import Stamp from '../../assets/stamp.png'
import { ShareContext } from '../../context/ShareContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose, faArrowLeft, faWarning, faInfo } from '@fortawesome/free-solid-svg-icons'
import { time } from '../../data/time'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import * as Constants from '../../constants';
import CenterLoader from '../../components/centerLoader'
import BackLoader from '../../components/backloader'
import Seal from '../../assets/seal.png';
import Sign2 from '../../assets/sign.png';
import { Button } from '@mui/material'
import JisPrompt from '../../components/jisprompt'
import JisAlert from '../../components/jisalert'
import { green, red } from '@mui/material/colors'
import moment from 'moment'


function ViewDoc(props) {
    const { sweared, isCfo, isThirdOpt, setWhichUpload, profile } = useContext(ShareContext)
   
    var location=useLocation();
  
    var {item} = location.state;
  //  var profileid=Constants.isServerEnv? Constants.getCookie("profilename"):'seniola1' ;
    const url=`${Constants.apiUrl}/gazette/DocumentView/${item.id}`;
     const cashier_stamp=`${Constants.rooturl}/resources/special/cashier_stamp.png`; //image path
    const urlSaveInst = `${Constants.apiUrl}/gazette/uploadinstrument/${profile.username}`;
    const urlInstrument=`${Constants.apiUrl}/gazette/instrument/${profile.username}`;
    


    const [cfoWarn, setCfoWarn] = useState(false)
    const [isDialog, setIsDialog] = useState(false)
    const [doc, setDocument] =useState({uplines:[],uplinesigns:[]})
    const [currectdoc, setCurrentDoc]=useState({upline:null,filenames:[]});
    const [uplineIndex, setUplineIndex]=useState(0);
    const [imgIndex, setImageIndex] =useState(0);
    const [isLoading,setIsLoading]= useState(false);
    const [uplineType, setUplineType] = useState('upline'); //upline, sign
    const [posPoint, setPosPoint] = useState({}); //this is for items that are yet added passport 1, Seal 2, Signature 3  {x--cord,y - cord,show bool,docid  instype, imgurl} 
    const [seal, setSeal]=useState('');
    const [passport, setPassport] =useState('');
    const [sign, setSign] =useState('');
    const [initial, setInitial] =useState('');
    const [stamp, setStamp] =useState('');
    const [pageIndex, setPageIndex]=useState(0);
    const [isSaved, setIsSaved] =useState(false);
    const [cashier_seal, setCashierSeal]=useState('')
   
   
    const [currentdate, setCurrendate] = useState(new Date());
     const [timestamp, setTimestamp] = useState(moment(currentdate).format("YYYY-MM-DD hh:mm a"));
   //load documents first, then load one by one
   const [posId, setPosId] =useState(0); //this is the main guy that is doing the selection
   const [dstart, setDStart]=useState({isDragging: false});
   const [imgs, setImgs]=useState([]);
   const [activeFile,setActiveFile] =useState({});

   const needpermission="Document saved successfully! Wait for the CFO to commission your document ";
   const noneedpermission="Document saved successfully! Wait for the CFO to initial your document";
   const cfoMsg=""
   const permissionList=item.caseType=='adr'?Constants.DocPermissionList_ADR:Constants.DocPermissionList;


   const onSaveInst=()=>{
        onUploadIns();
   }

   const [imgPrev, setImgPrev]=useState ({data:'', type:'', open:false});
   const [alert, setAlert]=useState ({open:false,title:'', subtitle:''})
   const [prompt, setPrompt]=useState ({open:false,title:'', subtitle:''})

   var pageRef=useRef(null);

    const navigate = useNavigate()

 const onOk=()=>{
    setAlert({...alert,open:false});
 }
 const onGotoDashboard=()=>{
    setAlert({...alert,open:false});
    navigate("/home/dashboard")
 }
 const onCancel=()=>{

 }

 const retrieveDocYear=()=>{
    
 }
  

    const confirmCaseDoc = () => {
        navigate('/upload/documents');
        setWhichUpload('Third')
    }

    useEffect(() => {
        onLoad();
        onLoadInstrument();
       console.log('am here in usefect');

       
      
      }, [item]);

      useEffect(() => {
        if (!pageRef.current) {
          // we do not initialize the observer unless the ref has
          // been assigned
          return;
        }
    
        // we also instantiate the resizeObserver and we pass
        // the event handler to the constructor
        const resizeObserver = new ResizeObserver(() => {
            console.log('in resize observer ')
            const divPos=pageRef.current.getBoundingClientRect();
            const start={
            
             initialX: divPos.x,
             initialY: divPos.y,
     
           }
           console.log('at use effect calculate init position');
      console.log(start);

           setDStart(start);
        });
        
        // the code in useEffect will be executed when the component
        // has mounted, so we are certain observedDiv.current will contain
        // the div we want to observe
        resizeObserver.observe(pageRef.current);
    
    
        // if useEffect returns a function, it is called right before the
        // component unmounts, so it is the right place to stop observing
        // the div
        return function cleanup() {
          resizeObserver.disconnect();
        }
      },
      // only update the effect if the ref element changed
      [pageRef.current])
    

      const onLoad= async()=>{
        //for account registration
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            if(data.code==0){
                setDocument(data);
                //load current first item
                setUplineIndex(0);
                setImageIndex(0);
                onCurrentDoc(data.uplines[0].id,"upline");

            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onCurrentDoc= async(id, ftype)=>{ //doctype=upline always this one
        //for account registration DocumentView
        const url=`${Constants.apiUrl}/gazette/singlefile/${id}/${ftype}`
        setCashierSeal(`${Constants.rooturl}/resources/special/cashier_seal_${id}.png`)
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            console.log('specific document');
            console.log(data);
            if(data.code==0 ){
                setCurrentDoc({...data});
            }else if(data.code==1){
                setCurrentDoc({...data, filenames:[]});
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onNextFile=()=>{
        if(imgs.length>0 && !isSaved){
            setAlert( {...alert, title:'Save Instrument', open:true, subtitle:`Please save the instrument before you see another document or you drag it off the screen before you continue.`, onOk })
            return;
        }

        setIsSaved(false);
        var size=doc.uplines.length;
        setPageIndex(0);
        setImgs([]);
        setPosPoint({})

        if(uplineIndex < (size-1)){

            var a=uplineIndex+1;
            setUplineIndex(a);
            setImageIndex(0);
            onCurrentDoc(doc.uplines[a].id,"upline");


        }else{
           // alert('What you seeing is the last file');
            setAlert(  {open:true,title:'Document', subtitle:'What you seeing is the last file', onOk});
        }
    
        
    }

    const onPrevFile=()=>{
        if(imgs.length>0 && !isSaved){
            setAlert( {...alert, title:'Save Instrument', open:true, subtitle:`Please save the instrument before you see another document or you drag it off the screen before you continue.`, onOk })
            return;
        }
        setIsSaved(false);
        console.log(uplineIndex);
        setPageIndex(0);
        setImgs([]);
        setPosPoint({})
        if(uplineIndex > 0){

            var a=uplineIndex-1;
            setUplineIndex(a);
            setImageIndex(0);
            onCurrentDoc(doc.uplines[a].id,"upline");

        }else{
            //alert('What you seeing is the first file');
            setAlert(  {open:true,title:'Document', subtitle:'What you seeing is the first file', onOk});
        }
    }


    //drag issue
    const onDrag = (e) => {
        /* dragCarer.current = position;*/
      
        const _start={
            ...dstart, x:e.clientX, y:e.clientY
          }
          setDStart(_start);
        
       
      };

      const scheduleDragEnter = (e,day, position) => {
        // dragOver.current = {day,position};
       
        e.preventDefault();
      };

      
    //passport 1, Seal 2, Signature 3 
    const onAppendPassport=()=>{
      /*   if(pageIndex != currectdoc.filenames.length-1){
            setAlert(  {open:true,title:'Append ', subtitle:'You can only append to last page', onOk});
          return;
        } */

         if(passport=='')
        {
          setAlert(  {open:true,title:'Append Passport', subtitle:'Please upload your passport', onOk});
          return;
        } 

        var _pos={...posPoint};
        _pos[1]={x:0,y:0,show:true,  instype:'Passport', imgurl:passport,id:1, start:{} , pageIndex}
        setPosId(1)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
        console.log('the value');
        console.log(_pos);
    }

    const onAppendSeal=()=>{
       if(profile.role== 'LegalCounsel'){
        if(permissionList.has(currectdoc.upline?.gazetteItemId) && !currectdoc.upline?.allowSeal){
            setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a seal on the document. This approval will be granted during the scheduled virtual call', onOk});
          return;
        } 
       }else{
        if(permissionList.has(currectdoc.upline?.gazetteItemId) && !currectdoc.upline?.allowSeal){
            setAlert(  {open:true,title:'Append ', subtitle:'Allow Legal Counsel to append seal before you, if you sure you have as CFO then. Please Next and Previous to same file to refresh', onOk});
          return;
        } 
       }



        

         if(seal=='')
        {
          setAlert(  {open:true,title:'Append Seal', subtitle:'Please upload your seal', onOk});
          return;
        } 

        console.log(imgs);
        var _pos={...posPoint};
        _pos[2]={x:0,y:0,show:true,  instype:'Seal', imgurl:seal,id:2,start:{}, pageIndex  }
        setPosId(2)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
        console.log('the value');
        console.log(_pos);
    }

    const onAppendCashierSeal=()=>{
        if(profile.role== 'LegalCounsel' || profile.role== 'Customer'){
            return;
        }


         console.log(imgs);
         var _pos={...posPoint};
         _pos[10]={x:0,y:0,show:true,  instype:'Cashier Seal', imgurl:cashier_seal,id:10,start:{}, pageIndex  }
         setPosId(10)
         setPosPoint(_pos);
         setImgs(Object.values(_pos)) 
         console.log('the value');
        console.log(_pos);
     }
     const onAppendCashierStamp=()=>{
        if(profile.role== 'LegalCounsel' || profile.role== 'Customer'){
            return;
        }


         console.log(imgs);
         var _pos={...posPoint};
         _pos[11]={x:0,y:0,show:true,  instype:'Cashier Stamp', imgurl:cashier_stamp,id:11,start:{}, pageIndex  }
         setPosId(11)
         setPosPoint(_pos);
         setImgs(Object.values(_pos)) 
         console.log('the value');
        console.log(_pos);
     }

    const onAppendSignature=()=>{
        if(permissionList.has(currectdoc.upline?.gazetteItemId) && !currectdoc.upline?.allowSign){
          //  setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled video virtual call". if you are sure the CFO has approved. Please click Next and Previous to the same file to refresh', onOk});
         setAlert(  {open:true,title:'Append ', subtitle:'Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call', onOk});
          return;
        } 

        if(sign=='')
        {
          setAlert(  {open:true,title:'Append Signature', subtitle:'Please upload your Signature', onOk});
          return;
        } 
        var _pos={...posPoint};
        _pos[3]={x:0,y:0,show:true,  instype:'signature', imgurl:sign,id:3,start:{}, pageIndex  }
        setPosId(3)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 

        console.log('the value');
        console.log(_pos);
    }

    const onAppendInitial=()=>{
       
        if(initial=='')
        {
          setAlert(  {open:true,title:'Append Initial', subtitle:'Please upload your Initial', onOk});
          return;
        } 
        var _pos={...posPoint};
        _pos[6]={x:0,y:0,show:true,  instype:'initial', imgurl:initial,id:6,start:{}, pageIndex  }
        setPosId(6)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 

        console.log('the value');
        console.log(_pos);
    }

    const onAppendStamp=()=>{
       

        if(stamp=='')
        {
          setAlert(  {open:true,title:'Append Stamp', subtitle:'Please upload your Stamp', onOk});
          return;
        } 
        var _pos={...posPoint};
        _pos[4]={x:0,y:0,show:true,  instype:'stamp', imgurl:stamp,id:4,start:{}, pageIndex  }
        setPosId(4)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
        console.log('the value');
        console.log(_pos);
    }
    const onAppendTimestamp=()=>{
       
        //5 for timestamp

      
        var _pos={...posPoint};
        _pos[5]={x:0,y:0,show:true,  instype:'timestamp', imgurl:'',id:5,start:{}, pageIndex, timestamp  }
        setPosId(5)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
        console.log('the value');
        console.log(_pos);
    }
    const onAppendTimestamp2=()=>{
       
        //5 for timestamp

      
        var _pos={...posPoint};
        _pos[7]={x:0,y:0,show:true,  instype:'timestamp', imgurl:'',id:7,start:{}, pageIndex, timestamp  }
        setPosId(7)
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
        console.log('the value');
        console.log(_pos);
    }


    const onMoveInstru=(ev)=>{
        console.log(ev);

       console.log(ev.pageX);
       console.log(ev.pageY);
       if(posId>0){
        
       var _pos={...posPoint};
       var aa=_pos[posId];
       _pos[posId]={...aa, x:ev.pageX,y:ev.pageY}
       setPosPoint(_pos);
       setImgs(Object.values(_pos)) 
       }
       

    }

    const onDragStart_old=(e, instid)=>{
        const containerRect = e.currentTarget.getBoundingClientRect();
       
        if(!dstart.isDragging){
            const start={ ...dstart,
            isDragging: true,
           
            offsetX: e.clientX - containerRect.left,
            offsetY: e.clientY - containerRect.top,
          }
          setDStart(start);
        }
        console.log('about main div')
       console.log(pageRef.current.getBoundingClientRect());
          
    }

    const onDragEnd_old=(e,instid)=>{
        console.log(imgs);
        console.log('Drag end');
        console.log(`x ${e.clientX}, y ${e.clientY} while init x:${dstart.initialX} init y: ${dstart.initialY}`)
        var _posId=posId;


       if(_posId!=instid){
            setPosId(instid);
            _posId=instid;
        } 
      
        var _pos={...posPoint};
   

        var aa=_pos[_posId];
        console.log("start posId: " + posId + " | selected pois: " + _posId) 
        const x_ =Math.abs (dstart.initialX- e.clientX )//- aa.start?.initialX;
        const y_ =Math.abs(dstart.initialY-e.clientY)  //- aa.start?.initialY; 

        const divPos=pageRef.current.getBoundingClientRect();
        console.log('the main div object size');
        console.log(divPos)

         const x =Math.abs ( e.clientX- divPos.x  - dstart.offsetX) //-dstart.initialX- aa.start?.initialX;
         const y =Math.abs(e.clientY- divPos.y -dstart.offsetY)  //-dstart.initialY- aa.start?.initialY; 
         if(x>(650)){
            //remove this item and return
            delete _pos[_posId];
            setPosPoint(_pos);
            setImgs(Object.values(_pos)) 
            return;
         }
        /*  const x= e.clientX;
         const y = e.clientY;*/
         console.log("formal X cal: " + x_ + " | Y cal: " + y_)
         console.log("X cal: " + x + " | Y cal: " + y)
        _pos[_posId]={...aa, x,y};
        console.log(_pos[_posId]);
        setPosPoint(_pos);
        setImgs(Object.values(_pos)) 
       
    }
    const onDragStart = (e, instid) => {
        const containerRect = e.currentTarget.getBoundingClientRect();
    
        if (!dstart.isDragging) {
            const start = {
                ...dstart,
                isDragging: true,
                offsetX: e.clientX - containerRect.left,
                offsetY: e.clientY - containerRect.top,
                initialX: e.clientX,
                initialY: e.clientY
            };
            setDStart(start);
        }
    
        console.log("About main div:");
        console.log(pageRef.current.getBoundingClientRect());
    };
    
    const onDragEnd = (e, instid) => {
        console.log(imgs);
        console.log("Drag end");
        console.log(`x: ${e.clientX}, y: ${e.clientY} | init x: ${dstart.initialX}, init y: ${dstart.initialY}`);
    
        let updatedPosId = posId;
    
        if (updatedPosId !== instid) {
            setPosId(instid);
            updatedPosId = instid;
        }
    
        const updatedPositions = { ...posPoint };
        const currentItem = updatedPositions[updatedPosId] || {};
    
        const divPos = pageRef.current.getBoundingClientRect();
        console.log("The main div object size:");
        console.log(divPos);
    
        const x = e.clientX - divPos.x - dstart.offsetX;
        const y = e.clientY - divPos.y - dstart.offsetY;
    
        if (x > 650) {
            console.log("Item is out of bounds. Removing...");
            delete updatedPositions[updatedPosId];
            setPosPoint(updatedPositions);
            setImgs(Object.values(updatedPositions));
            return;
        }
    
        console.log(`Calculated X: ${x}, Y: ${y}`);
    
        updatedPositions[updatedPosId] = { ...currentItem, x, y };
        console.log(updatedPositions[updatedPosId]);
    
        setPosPoint(updatedPositions);
        setImgs(Object.values(updatedPositions));
    };
    

    const previewImage= async (event, inst)=> {
        console.log("file read");
        const input = event.target;
       // const preview = document.getElementById('preview');
        console.log(input);
        if (input.files && input.files[0]) {
            var b64=await Constants.toBase64(input.files[0]);
            setImgPrev({open:true,data:b64,type:inst, title:"Upload "+inst,file:input.files[0], onCancel:()=>setImgPrev({...imgPrev,open:false}) });
            setActiveFile({open:true,data:b64,type:inst, title:"Upload "+inst,file:input.files[0], onCancel:()=>setImgPrev({...imgPrev,open:false}),onOk:onSaveInst  });
            console.log("file read");

          /* const reader = new FileReader();
  
          reader.onload = function (e) {
            console.log('file read now... ')
           // preview.src = e.target.result;
            setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
          };
  
          reader.readAsDataURL(input.files[0]); */
        }
      }

      const onAgree=()=>{
        setImgPrev({...imgPrev,open:false});
        onSaveInst();
      }
    const onUploadIns= async()=>{
        console.log('imgPrev data');
        console.log(imgPrev);
     
      
            setIsLoading(true);    
        //setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
            var ext=imgPrev.file.name.split('.')[1];
            var rdata={base64: imgPrev.data.split(',')[1],instType:imgPrev.type,ext,changereason:'Initial'};
            // Sending the FormData using fetch
            fetch(urlSaveInst, {
            method: 'POST',
            body: JSON.stringify(rdata),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                    setImgPrev({...imgPrev,open:false})
                   setAlert( {...alert, title:imgPrev.type, open:true, subtitle:`Saved ${imgPrev.type} successfully`, onOk })
                   console.log(`data instPath ${data.instPath} , imgPrev.type ${imgPrev.type}`);
                   onSetImg(data.instPath,imgPrev.type);
                }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

    const onAppendOnServer= ()=>{
            setPrompt({open:false});
              
            const url = `${Constants.apiUrl}/gazette/appendInstrument/${currectdoc.upline?.id}/${profile.username}/${dynamicWidth}/${staticHeight}/${aspectRatio}`;
            var ll=[];
            for( const x of imgs ){
                var l= {InstrumentType: x.instype,x:x.x,y:x.y, url:x.imgurl , pageIndex:x.pageIndex, timestamp};
                ll.push(l);
            }
            

            if(ll.length==0){
                setAlert( {...alert, title:imgPrev.type, open:true, subtitle:`Its either you did not append any instrument or there is no other instrument required.`, onOk })
                return;
            }
            setIsLoading(true); 
            console.log('server positioning *****************');
            console.log(ll);
            // Sending the FormData using fetch
            fetch(url, {
            method: 'POST',
            body: JSON.stringify(ll),
            headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                    setImgPrev({...imgPrev,open:false})
                    //if profile.role=='legal councel'
                    if(profile.role== 'LegalCounsel'){
                        setAlert( {...alert, open:true, title:'Save Document', open:true, subtitle:permissionList.has(currectdoc.upline?.gazetteItemId)? needpermission:noneedpermission, onOk })
                    }else{
                        if(data.incompleted==0){
                            setAlert( {...alert,open:true, title:'Process Document', open:true, subtitle:`You have worked on all document(s), the case will now move to Process Section Assessors' Queue `, onOk: onGotoDashboard })
                        }else{
                            setAlert( {...alert,open:true, title:'Process Document', open:true, subtitle:`Processed Successfully. Document remain to be processed ${data.incompleted}`, onOk })
                        }
                    }
                
                setPrompt({...prompt, open:false, });
              //  onSetImg(data.instPath,imgPrev.type);
              setIsSaved(true);

             UpdateInst(currectdoc.upline?.id);
             

                }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

    const UpdateInst=(id)=>{ //the id of the upline
         //update the items
              //setList(list.map(l=>l.id==id?{...l,age:age}:l));
              //if the user is legalcounsel, just update legal counsel part
              //if the user is others then it update their own

              //const [doc, setDocument] =useState({uplines:[],uplinesigns:[]})
              //const [posPoint, setPosPoint] = useState({});
            var  uplines = doc.uplines;
                var pass= posPoint[1];
              var seal= posPoint[2];
              var sign= posPoint[3];
           // var updatedup 
            if(profile.role== 'LegalCounsel'){
              

              if(pass!=null){
                uplines= uplines.map(l=>l.id==id?{...l,passportPath:'uploaded'}:l)
              }
              if(seal!=null){
                uplines= uplines.map(l=>l.id==id?{...l,sealPath:'uploaded'}:l)
              }
              if(sign!=null){
                uplines= uplines.map(l=>l.id==id?{...l,signaturePath:'uploaded'}:l)
              }

             } else{
                /* if(pass!=null){
                    uplines= uplines.map(l=>l.id==id?{...l,passportPath:'uploaded'}:l)
                  } */
                  if(seal!=null){
                    uplines= uplines.map(l=>l.id==id?{...l,oathSealPath:'uploaded'}:l)
                  }
                  if(sign!=null){
                    uplines= uplines.map(l=>l.id==id?{...l,oathSignature:'uploaded'}:l)
                  }
                  if(stamp!=null){
                    uplines= uplines.map(l=>l.id==id?{...l,oathStamp:'uploaded'}:l)
                  }
             }

              setDocument({uplines});

             
        
    }

    const onSetImg =(path,type)=>{
        const ct=type.toLowerCase()
        if(ct=='seal'){
            setSeal(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='passport'){
            setPassport(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='signature'){
            setSign(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='stamp'){
            setStamp(  `${Constants.docUrl}instrument/${path}`);
        }
        else if(ct=='initial'){
            setInitial(  `${Constants.docUrl}instrument/${path}`);
        }
       /*  else if(ct=='timestamp'){
            setTimestamp(  `${Constants.docUrl}instrument/${path}`);
        } */
    }

    const onLoadInstrument= async()=>{
        //for account registration
        console.log(`the calling url ${urlInstrument}`);
        try {
            setIsLoading(true);
            const resp = await fetch(urlInstrument, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            if(data.code==0){
                //check if it contain any of the items
                console.log('the loaded instrument');
                console.log(data);
                for( const x of data.inst ){
                    onSetImg(x.instPath, x.instrument)
                }
                
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onSavePostion= ()=>{
         setPrompt({open:true,title:'Save Instrument Positioning', subtitle:'Please note that saving instrument positioning will modify the document and the process is not reversable. Do you want to continue?',
        onCancel:()=>{setPrompt({...prompt, open:false})}, onOk:onAppendOnServer}); 
    }

    const onNextPage=()=>{
        if(pageIndex < currectdoc.filenames.length-1){
            var ipage=pageIndex+1;
            setPageIndex(ipage);
        }else{
            console.log('its not there again '+pageIndex);
        }
    }

    const onPrevPage=()=>{
         if(pageIndex > 0){
            var ipage=pageIndex-1;
            setPageIndex(ipage);
        }else{
            console.log('its not there again '+pageIndex);
        }
    }

    const onIsCompleted=()=>{
        // go to home page, when work is completed
        setAlert({...alert,open:false});
        window.location.replace(`${Constants.primarySite}/Users.aspx`)
    }
    const onAllowSign =(e)=>{
        console.log(e.target.value);
        //setCurrentDoc({...currectdoc,upline.allowSign})
        onAllow(true, 'sign');

    }
    const onAllowSeal =(e)=>{
        console.log(e.target.value);
        onAllow(true, 'seal');
    }

    const onAllow=(isAllow, instType)=>{
        const url=`${Constants.apiUrl}/gazette/allowinstrument/${currectdoc.upline?.id}`;
        var ll={uplineId:currectdoc.upline?.id,isAllow, instType, cfoUserid: profile.username  }
        setIsLoading(true); 
         
            fetch(url, {
            method: 'POST',
            body: JSON.stringify(ll),
            headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                   if(instType=='seal'){
                    var up=currectdoc.upline;
                    up.allowSeal=isAllow;
                    setCurrentDoc({...currectdoc, upline:up})
                   }
                   else if(instType=='sign'){
                    var up=currectdoc.upline;
                    up.allowSign=isAllow;
                    setCurrentDoc({...currectdoc, upline:up})
                   }
             

                }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

    const onImgTimestamp =()=>{

    }

    const onLoadTimestamp= async()=>{
        //for account registration
        var tstr=moment(currentdate).format("YYYY-MM-DD"); //
        const tsUrl = `${Constants.apiUrl}/gazette/uploadinstrument/${profile.username}/${tstr}`;
        console.log(`the calling url ${tsUrl}`);
        try {
            setIsLoading(true);
            const resp = await fetch(tsUrl, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            if(data.code==0){
                //check if it contain any of the items
                console.log('the loaded instrument');
                console.log(data);
                for( const x of data.inst ){
                    onSetImg(x.instPath, x.instrument)
                }
                
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
    
    //about image and its rendered
    const imageRef = useRef(null);
  const [dynamicWidth, setDynamicWidth] = useState(0);
  const staticHeight=900;
  const [aspectRatio, setAspectRatio] = useState(null);
  const handleImageLoad = () => {
    if (imageRef.current) {
        const { naturalWidth, naturalHeight } = imageRef.current;
      setAspectRatio((naturalWidth / naturalHeight).toFixed(2));
      setDynamicWidth(imageRef.current.clientWidth);
    }
  };
  //end image rendered
  return (
    <div className='view-doc'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h3>Document View</h3>
                    </div>
                </div>
                <p className="nav-status">Home/Document-View</p>
            </div>
            
            <div className="document">
                <div className="doc-side">
                    <div className="top-bar">
                        <button onClick={onPrevFile} className='planred'>Previous Document</button>
                        <div className="namedoc">
                            <p>Current File: <span>{currectdoc.upline?.documentTitle}</span> </p>
                        </div>
                        <button onClick={onNextFile} className='planred'>Next Document</button>
                    </div>  
                    <div className="wrapper" style={{width:dynamicWidth, maxHeight:staticHeight,  backgroundColor:'GrayText', padding:0, position:'relative', alignSelf:'center', overflow:"auto"}}
                     /* onMouseMove={onMoveInstru} onDoubleClick={()=>setPosId(0)} */ ref={pageRef}  >
                      
                      
                        {/* {currectdoc.upline!=null && <span>{currectdoc.filenames[0]} <strong>{Constants.AbsoluteFiletoRelative(currectdoc.filenames[0])}</strong></span> } */}
                       {currectdoc.filenames.length>0 && <img ref={imageRef} onLoad={handleImageLoad} src={Constants.AbsoluteFiletoRelative(currectdoc.filenames[pageIndex])} style={{ height:staticHeight,margin:0}} />} 
                       {currectdoc.filenames.length==0 && <h2>You are yet to upload the file. Goto the link <Link to={`/upload/documents/${item.caseFeeId}`}><span>Upload Files</span> </Link> </h2>}
                    
                    { imgs.map((item, id) => { return ( item.pageIndex==pageIndex &&
                           <div key={id}>
                           {(item.id==5 || item.id==7)?<div style={{height: 100,margin:0, position:'absolute', top:item.y, left:item.x}}  draggable onDrag={(e)=>onDrag(e,item.id)} 
                           onDragStart={(e)=>onDragStart(e,item.id)} onDragEnd={(e)=>onDragEnd(e,item.id)}><strong>{moment(currentdate).format("YYYY-MM-DD hh:mm a")}</strong> </div>: 
                           <img src={item.imgurl} style={{ height:100,margin:0, position:'absolute', top:item.y, left:item.x}} draggable onDrag={(e)=>onDrag(e,item.id)} 
                           onDragStart={(e)=>onDragStart(e,item.id)} onDragEnd={(e)=>onDragEnd(e,item.id)} />}  
                           
                           </div>
                        )})}
                     
                       
                    </div>
                </div>
               
                 <div className='actions'>
                    <p className="title">e-Swearing Quick Actions</p>  
                    { (profile.role=='CommissionerForOaths' || profile.role=='e-CFO'|| profile.role=='e-Commissioner for Oaths' || profile.role=='ACR' || profile.role=='e-ACR' ) && permissionList.has(currectdoc.upline?.gazetteItemId) && <div className='check-sign'>
                        <div>
                            <input type="checkbox" id='check-cfo' checked={currectdoc.upline?.allowSign} disabled={currectdoc.upline?.allowSign} onChange={(e)=> onAllowSign(e)} />
                            <label htmlFor="check-cfo" >Allow to Append Signature</label>
                        </div>
                        <div>
                            <input type="checkbox" checked={currectdoc.upline?.allowSeal} id='check-cfo'  disabled={currectdoc.upline?.allowSeal} onChange={(e)=> onAllowSeal(e)}/>
                            <label htmlFor="check-cfo">Allow to Append Seal</label>
                        </div>
                        
                    </div> } 
                    
                        {permissionList.has(currectdoc.upline?.gazetteItemId) && <div>{(currectdoc.upline?.allowSign && currectdoc.upline?.allowSeal)?<span style={{color:green[500], fontWeight:'bold'}}>permission granted for you to append your signature/seal </span> :<span style={{color:red[500], fontWeight:'bold'}}>Permission required for item </span>}</div>}
                    <div> 
{(profile.role== 'LegalCounsel' || profile.role== 'Customer') ?
                    <div className="btns" style={{flexWrap:'wrap'}}>
                            <div className="append">
                                <img src={seal==''? Seal : seal} alt="Seal" style={{ height:100}} />
                                <div className="append-create">
                                    <input type="file" id="append-seal" accept="image/*" onChange={(e)=>previewImage(e,"Seal") } />
                                    
                                </div>
                                <button className='black' onClick={onAppendSeal}>Append Seal</button>
                            </div> 
                          <div className="append">
                                <img src={sign==''? Sign:sign} alt="Signature"  style={{ height:100}}/>
                                <div className="append-create">
                                    <input type="file" id="append-sign"  accept="image/*" onChange={(e)=>previewImage(e,"Signature") } />
                                    
                                </div>
                                <button className='black' onClick={onAppendSignature}>Append Signature</button>
                            </div>  
                           

                            <div className="append">
                                <img src={passport==''? Sign:passport} alt="Passport"  style={{ height:100}} />
                                <div className="append-create">
                                    <input type="file" id="append-sign"  accept="image/*" onChange={(e)=>previewImage(e,"Passport") } />
                                    
                                </div>
                                <button className='black' onClick={onAppendPassport}>Append Passport</button>
                            </div>

                            <div className="append">
                                <img src={stamp==''? Sign:stamp} alt="Stamp"  style={{ height:100}}/>
                                <div className="append-create">
                                    <input type="file" id="append-stamp"  accept="image/*" onChange={(e)=>previewImage(e,"Stamp") } />
                                    
                                </div>
                                <button className='black' onClick={onAppendStamp}>Append Stamp</button>
                            </div>
                             <div className="append">
                               
                                <div style={{width:100, height:100}}></div>
                                <div className="append-create">
                                    <input type="text" id="append-time-stamp" value={moment(currentdate).format("YYYY-MM-DD hh:mm a")} disabled={true}  />
                                    
                                </div>
                                <button className='black' onClick={onAppendTimestamp}>Append Timestamp</button>
                            </div>
                         
                        </div>:
                        <div className="btns"  style={{flexWrap:'wrap'}}>
                             <div className="append">
                                <img src={seal==''? Seal : seal} alt="Seal" style={{ height:100}} />
                                <div className="append-create">
                                    <input type="file" id="append-seal" accept="image/*" onChange={(e)=>previewImage(e,"Seal") } />
                                    
                                </div>
                                <button className='black' onClick={onAppendSeal}>Append {isCfo && 'CFO'} Seal</button>
                            </div> 
                            <div className="append">
                                <img src={cashier_seal} alt="Cashier Seal" style={{ height:150}} />
                               
                                <button className='black' onClick={onAppendCashierSeal}>Append Cashier Seal</button>
                            </div> 
                            <div className="append">
                                <img src={cashier_stamp} alt="Cashier Stamp" style={{ height:150}} />
                               
                                <button className='black' onClick={onAppendCashierStamp}>Append Cashier Stamp</button>
                            </div> 
                           <div className="append">
                                <img src={sign==''? Sign:sign} alt="Signature"  style={{height:100}}/>
                                <div className="append-create">
                                    <input type="file" id="append-sign"  accept="image/*" onChange={(e)=>previewImage(e,"Signature") } />
                                    
                                </div>
                                <button className='black' onClick={onAppendSignature}>Append CFO Signature</button>
                            </div>  

                            <div className="append">
                                <img src={initial==''? Sign:initial} alt="Initial"  style={{ height:100}}/>
                                <div className="append-create">
                                    <input type="file" id="append-sign"  accept="image/*" onChange={(e)=>previewImage(e,"Initial") } />
                                    
                                </div>
                                <button className='black' onClick={onAppendInitial}>Append CFO Initial</button>
                            </div>  

                             <div className="append">
                                <img src={stamp==''? Sign:stamp} alt="Stamp"  style={{ height:100}}/>
                                <div className="append-create">
                                    <input type="file" id="append-stamp"  accept="image/*" onChange={(e)=>previewImage(e,"Stamp") } />
                                    
                                </div>
                                <button className='black' onClick={onAppendStamp}>Append {isCfo && 'CFO'} Stamp</button>
                            </div>
                             <div className="append">
                               
                                <div style={{ height:100}}></div>
                                <div className="append-create">
                                    <input type="text" id="append-time-stamp" value={moment(currentdate).format("YYYY-MM-DD hh:mm a")} disabled={true}  />
                                    
                                </div>
                                <button className='black' onClick={onAppendTimestamp}>Append Timestamp</button>
                            </div>
                            <div className="append">
                               
                               <div style={{height:100}}></div>
                               <div className="append-create">
                                   <input type="text" id="append-time-stamp" value={moment(currentdate).format("YYYY-MM-DD hh:mm a")} disabled={true}  />
                                   
                               </div>
                               <button className='black' onClick={onAppendTimestamp2}>Append Timestamp 2</button>
                           </div>

                        </div> }     
                        
                       
                   
                    <div>
                      <div className="details">
                        <div className="row">
                            <p className="name">Document Reference ID</p>
                            {/* <p className="answer">{`DOC/JS/${item.caseFeeId}/${item.id}/${currectdoc.upline?.id}`}</p> */}
                            <p className="answer">{`${item.caseNumber}/HC/${currectdoc.upline?.id}}`}</p>
                        </div>
                        <div className="row">
                            <p className="name">Case Title</p>
                            <p className="answer">{item.caseTitle}</p>
                        </div>
                        <div className="row">
                            <p className="name">Case Number</p>
                            <p className="answer">{item.caseNumber}</p>
                        </div>
                        <div className="row">
                            <p className="name">Number of Documents</p>
                            <p className="answer">{doc?.uplines.length }</p>
                        </div>
                        <div className="row">
                            <p className="name">Scheduled for e-Swearing</p>
                            <p className="answer">Yes</p>
                        </div>
                        <div className="row">
                            <p className="name">e-Swearing Schedule Date</p>
                            <p className="answer">{item.schedule==null?'N/A':Constants.formatDate(item.schedule)}</p>
                        </div>
                        <div className="row">
                            <p className="name">e-Swearing Schedule Time</p>
                            <p className="answer">{item.schedule==null?'N/A':Constants.formatTime(item.schedule)}</p>
                        </div>
                        <div className="row">
                            <p className="name">Zoom Link</p>
                            <p className="answer  zoom-link">{item.zoomLink!=null && <a href={item.zoomLink} target='_blank'>{item.zoomLink}</a>} </p>
                        </div>
                    </div>
                    
                    <div>
                        <button className='black' onClick={onSavePostion}>Save Instrument Positioning</button>
                        <p style={{color:'red'}}><FontAwesomeIcon icon={faInfo} /> Click this button after appending all media to each document before moving to the next document </p>
                    </div>  
                    </div>
                    </div>
                    
                    
                    
                    
                </div>
            </div>
            <div className="down" style={{width:"50%"}}>
            
                <div className="goBack" onClick={() => window.history.back()}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <p>Back</p> {/* <a href={`${Constants.docUrl}${currectdoc.upline?.filename}`} target='_blank'>View on Browser</a> */}
                   
                </div>

                {currectdoc.filenames.length==0 && <Link to={`/upload/documents/${item.caseFeeId}`}><span>Upload Files</span> </Link>}
                {currectdoc.filenames.length>0 && <div> <strong style={{fontSize:16, margin:16}}>{pageIndex+1 } / {currectdoc.filenames.length}</strong> 
        
                    <button onClick={onPrevPage} className='planred'>Previous Page</button>
                    <button  onClick={onNextPage} type='button' className='planred'>Next Page</button></div>} 

                {isCfo && <button onClick={() => setIsDialog(true)}>Edit Schedule </button> }
                { isThirdOpt && <button onClick={() => confirmCaseDoc()}>Confirm Document</button> }
            </div>
        </div>
      {cfoWarn && <div className={   'warning show' }>
            <div className="container">
                <div className="icon" onClick={() => setCfoWarn(false)}>
                    <FontAwesomeIcon icon={faClose} />
                </div>
                <div className="body">
                    <h3>Appending Signature</h3>
                    <p>You are not allowed to upload your signature yet. Please wait for the Chief for Oath (CFO) authorizes you to upload your signature. In the mean time, you can upload your seal and passport </p>
                    <button onClick={() => setCfoWarn(false)}>Ok</button>
                </div>
            </div>
        </div> }  
      {isDialog && <div className={  'dialog open' }>
            <div className="container">
                <div className="icon" onClick={() => setIsDialog(false)}>
                    <FontAwesomeIcon icon={faClose} />
                </div>
                <div className="body">
                    <h3>Schedule</h3>
                    <div className="form">
                        <div className="input">
                            <label htmlFor="zoom-link">Please input the zoom link:</label>
                            <input type="text" id='zoom-link' />
                        </div>
                        <div className="inputs">
                            <div className="input">
                                <label htmlFor="zoom-date">Scheduled Date</label>
                                <input type="date" id="zoom-date" />
                            </div>
                            <div className="input">
                                <label htmlFor="zoom-time">Scheduled Time</label>
                                <select id="zoom-time">
                                    <option value="" disabled>Select Time</option>
                                    {
                                        time.map((item, id) => {return (
                                            <option key={id} value={item.value}>{item.time}</option>
                                        )})
                                    }
                                </select>
                            </div>
                        </div>
                        <button type='submit'>Schedule</button>
                    </div>
                </div>
            </div>
        </div>}  
        <BackLoader open={isLoading}  />
        <JisPrompt {...imgPrev} onOk={onAgree}>
            <p style={{flexDirection:'row', alignContent:'center', alignItems:'center'}}>
           {imgPrev.data!=null && <img src={imgPrev.data} style={{height:100}} alt={imgPrev.type} />}     
                <strong>Are you ready to save this {imgPrev.type} {imgPrev.file?.name} ?</strong>
            </p>
        </JisPrompt>
       {alert.open && <JisAlert {...alert} />} 
        <JisPrompt {...prompt}>
            
            <p>{prompt.subtitle}</p>
        </JisPrompt>
    </div>
  )
}

export default ViewDoc